// Compat shim for the parts of BootstrapVue 2 that bootstrap-vue-next dropped
// or that we still need globally. The b-* component tags themselves are
// auto-imported per-file by unplugin-vue-components + BootstrapVueNextResolver
// (configured in vue.config.js); this plugin only fills the gaps.
//
// Gaps:
//   1. <b-icon> / <b-icon-*> — BVN removed icon components in favor of plain
//      bootstrap-icons CSS classes.
//   2. <b-input-group-prepend> / <b-input-group-append> — Bootstrap 5 dropped
//      these wrapper concepts; emulate with passthrough divs.
//   3. v-b-tooltip / v-b-popover / v-b-toggle / v-b-scrollspy directives —
//      registered globally so existing templates keep working.

import { h } from 'vue'
import { vBTooltip, vBPopover, vBToggle, vBScrollspy } from 'bootstrap-vue-next'

// Render functions are used instead of `template:` strings because the project
// builds against vue.runtime.esm-bundler (no runtime template compiler).

const BIcon = {
  name: 'BIcon',
  // animation/variant are BV2 BIcon props still used in templates (spinners, colored icons)
  props: { icon: { type: String, default: '' }, animation: { type: String, default: '' }, variant: { type: String, default: '' } },
  setup (props) {
    return () => h('i', {
      class: [props.icon ? `bi bi-${props.icon}` : 'bi', props.animation && `bi-anim-${props.animation}`, props.variant && `text-${props.variant}`],
      'aria-hidden': 'true'
    })
  }
}

const makeIconAlias = (iconName) => ({
  name: `BIcon${iconName.split('-').map(p => p[0].toUpperCase() + p.slice(1)).join('')}`,
  setup () {
    return () => h('i', {
      class: `bi bi-${iconName}`,
      'aria-hidden': 'true'
    })
  }
})

const BInputGroupAppend = {
  name: 'BInputGroupAppend',
  setup (_, { slots }) {
    return () => h('div', { class: 'input-group-append' }, slots.default ? slots.default() : [])
  }
}
const BInputGroupPrepend = {
  name: 'BInputGroupPrepend',
  setup (_, { slots }) {
    return () => h('div', { class: 'input-group-prepend' }, slots.default ? slots.default() : [])
  }
}

// Registered icon aliases. Add new ones here when templates start using them.
const iconAliases = {
  BIconCameraVideoFill: makeIconAlias('camera-video-fill'),
  BIconPerson: makeIconAlias('person')
}

const kebab = (s) => s.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase()

export default {
  install (app) {
    const register = (name, component) => {
      app.component(name, component)
      app.component(kebab(name), component)
    }

    register('BIcon', BIcon)
    register('BInputGroupAppend', BInputGroupAppend)
    register('BInputGroupPrepend', BInputGroupPrepend)

    Object.entries(iconAliases).forEach(([name, component]) => register(name, component))

    app.directive('b-tooltip', vBTooltip)
    app.directive('b-popover', vBPopover)
    app.directive('b-toggle', vBToggle)
    app.directive('b-scrollspy', vBScrollspy)
  }
}
